import { privateAxios } from "@src/axios.config";

// Get all notifications (with optional filters)
export const getNotifications = async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.is_read !== undefined) {
        queryParams.append('is_read', params.is_read);
    }
    if (params.type) {
        queryParams.append('type', params.type);
    }
    const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
    return await privateAxios.get(`/api/notifications${query}`);
};

// Get unread notification count
export const getNotificationCount = async () => {
    return await privateAxios.get('/api/notifications/count');
};

// Mark notifications as read
export const markNotificationsRead = async (notificationIds = [], markAll = false) => {
    return await privateAxios.post('/api/notifications/mark-read', {
        notification_ids: notificationIds,
        mark_all: markAll
    });
};

// Delete a single notification
export const deleteNotification = async (notificationId) => {
    return await privateAxios.delete(`/api/notifications/${notificationId}`);
};

// Delete all read notifications
export const deleteReadNotifications = async () => {
    return await privateAxios.delete('/api/notifications/delete?delete_read=true');
};




